/**
 * @voltxampere/ui — DeleteCommand (Sprint 13)
 *
 * Remove components and / or wires by id. The constructor
 * captures the snapshot of the targets *before* deletion so
 * `undo` can restore them — without this, deletion would
 * irreversibly forget the data.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class DeleteCommand {
    targets;
    snapshot;
    componentIds;
    wireIds;
    constructor(targets, circuit) {
        this.targets = targets;
        const componentIds = new Set();
        const wireIds = new Set();
        for (const t of targets) {
            if (t.kind === "component")
                componentIds.add(t.id);
            else
                wireIds.add(t.id);
        }
        this.componentIds = componentIds;
        this.wireIds = wireIds;
        this.snapshot = {
            components: circuit.components.filter((c) => componentIds.has(c.id)),
            wires: circuit.wires.filter((w) => wireIds.has(w.id)),
        };
    }
    do(circuit) {
        return {
            ...circuit,
            components: circuit.components.filter((c) => !this.componentIds.has(c.id)),
            wires: circuit.wires.filter((w) => !this.wireIds.has(w.id)),
        };
    }
    undo(circuit) {
        // Restore in original order — append snapshot back. Order
        // among restored items matches the snapshot (which itself
        // matched circuit order at construction time).
        return {
            ...circuit,
            components: [...circuit.components, ...this.snapshot.components],
            wires: [...circuit.wires, ...this.snapshot.wires],
        };
    }
    describe() {
        const total = this.targets.length;
        return `${String(total)} öge silindi`;
    }
}
//# sourceMappingURL=delete.js.map